import { render, staticRenderFns } from "./OmniFooter.vue?vue&type=template&id=6c02114a&scoped=true"
import script from "./OmniFooter.vue?vue&type=script&lang=js"
export * from "./OmniFooter.vue?vue&type=script&lang=js"
import style0 from "./OmniFooter.vue?vue&type=style&index=0&id=6c02114a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c02114a",
  null
  
)

export default component.exports